import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('power_kits_48v_system');

    return (
        <div className={styles.TheComp}>
            <p className="text">
                {t.rich('TC_text', {
                    w: (text: string) => <span className="text-title">{text}</span>,
                    l: (text: string) => <span className="text-link">{text}</span>,
                })}
            </p>
        </div>
    );
}
